import React from "react";
import "./index.scss";
import {getFirstThree} from './utils';
import PerformerPill from '../react-performer-pill/PerformerPill.js';
import {Link} from 'react-router-dom';
import ListingTitle from "./ListingTitle";

class PerformerSuggestions extends React.Component {
  componentDidMount() {
    this.props.updatePerformerSuggestions(this.props.id);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.props.updatePerformerSuggestions(this.props.id);
    }
  }

  render() {
    const {id, performerSuggestions, showPerformerPills, queryType} = this.props;
    return (
      (performerSuggestions !== undefined) && (
        <div className={`PerformerSuggestions__container ${showPerformerPills ? '' : 'noPills'}`}>
          <div className={`PerformerSuggestions__contentsWrapper`}>
            <div className="PerformerSuggestions__bigText">{id.toUpperCase()}</div>
            <div className="PerformerSuggestions__title">
              <h2>
                <ListingTitle listingType={queryType} listingTitle={id} />
              </h2>
            </div>
            {(showPerformerPills && performerSuggestions.length > 0) && (
              <div className="PerformerSuggestions__pills">
                {getFirstThree(performerSuggestions).map((ps, i) => {
                  return (
                    <Link to={`/sell/searchEvent?id=${ps.id}&type=${ps.type}&q=${ps.title}`} key={`${ps.title}_${i}}`}>
                      <PerformerPill performerSuggestion={ps} propClassName="PerformerSuggestions__pills--rightMargin" />
                    </Link>
                  );
                })
                }
              </div>
            )}
          </div>
        </div>
      )
    );
  }
}

export default PerformerSuggestions;
